import React, { useState } from "react";
import axios from "axios";
import CryptoJS from "crypto-js";
import { BASE_URL } from "../../config";
import { useNavigate } from "react-router-dom";
import bgImage from "../../Assets/land.jpeg";

const Register = () => {
  const [form, setForm] = useState({
    fullname: "",
    username: "",
    password: "",
    province: "",
    city_municipality: "",
    role: "Farmer",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setError("");

    const payload = {
      fullname: form.fullname.trim(),
      username: form.username.trim(),
      password: CryptoJS.MD5(form.password).toString(),
      role: form.role.toLowerCase(),
      province: form.province.trim(),
      city_municipality: form.city_municipality.trim(),
    };

    try {
      await axios.post(`${BASE_URL}/lisa_users/add`, payload);
setMessage("Account created successfully!");
      setForm({
        fullname: "",
        username: "",
        password: "",
        province: "",
        city_municipality: "",
        role: "Farmer",
      });

      setTimeout(() => navigate("/"), 1500);
    } catch (err) {
      if (err.response?.status === 409) {
        setError("Username already exists");
      } else {
        setError(err.response?.data?.message || "Server error");
      }
    }

    setLoading(false);
  };

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}></div>

      <div style={cardStyle}>
        <h2 style={titleStyle}>Sign Up</h2>

        {message && <p style={successStyle}>{message}</p>}
        {error && <p style={errorStyle}>{error}</p>}

        <form onSubmit={handleSubmit}>
          <input
            name="fullname"
            placeholder="Full Name"
            value={form.fullname}
            onChange={handleChange}
            required
            style={inputStyle}
          />

          <input
            name="username"
            placeholder="Username"
            value={form.username}
            onChange={handleChange}
            required
            style={inputStyle}
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
            style={inputStyle}
          />

          <select
            name="role"
            value={form.role}
            onChange={handleChange}
            style={inputStyle}
          >
            <option value="Farmer">Farmer</option>
            <option value="Administrator">Administrator</option>
          </select>

          <input
            name="province"
            placeholder="Province"
            value={form.province}
            onChange={handleChange}
            required
            style={inputStyle}
          />

          <input
            name="city_municipality"
            placeholder="City / Municipality"
            value={form.city_municipality}
            onChange={handleChange}
            required
            style={inputStyle}
          />

          <button type="submit" disabled={loading} style={buttonStyle}>
            {loading ? "Creating..." : "Create Account"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Register;

/* ================= STYLES ================= */

const pageStyle = {
  width: "100%",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  paddingTop: "40px",
  backgroundImage: `url(${bgImage})`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  position: "relative",
};

const overlayStyle = {
  position: "absolute",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  zIndex: 0,
};

const cardStyle = {
  width: "100%",
  maxWidth: "500px",
  padding: "30px",
  borderRadius: "16px",
  background: "rgba(231, 247, 247, 0.15)",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
  boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
  border: "1px solid rgba(255,255,255,0.2)",
  zIndex: 1,
  position: "relative",
};

const titleStyle = {
  textAlign: "center",
  marginBottom: "20px",
  fontWeight: "bold",
  color: "#fff",
};

const inputStyle = {
  width: "100%",
  padding: "12px",
  margin: "8px 0",
  borderRadius: "10px",
  border: "1px solid rgba(0,0,0,0.15)",

  // ✅ FIX: solid white background (not transparent)
  background: "#ffffff",

  // ✅ FIX: black text for readability
  color: "#111",

  fontSize: "14px",
  outline: "none",
};

const buttonStyle = {
  width: "100%",
  padding: "12px",
  marginTop: "15px",
  borderRadius: "999px",
  border: "none",
  background: "rgba(52, 142, 56, 0.9)",
  color: "white",
  fontWeight: "bold",
  cursor: "pointer",
};

const successStyle = {
  color: "#7CFC00",
  textAlign: "center",
};

const errorStyle = {
  color: "#ff6b6b",
  textAlign: "center",
};